<template>
  <ComboboxOption as="template" v-slot="{ active, selected }" :value="wrapper" :disabled="disabled">
    <li
      v-bind="$attrs"
      class="relative flex cursor-pointer items-center space-x-2 px-1 py-2 select-none"
      :class="
        active
          ? 'bg-primary text-on-primary'
          : muted
            ? 'dark:bg-surface/5 bg-gray-50 text-gray-500 dark:text-gray-400'
            : ''
      "
    >
      <span v-if="$slots['before-text']" class="flex items-center">
        <slot name="before-text" />
      </span>

      <slot name="text" v-bind="{ active, selected }">
        <span :class="['flex min-w-0 grow items-center truncate', selected && 'font-semibold']">{{
          text
        }}</span>
      </slot>

      <span v-if="$slots['after-text']" class="flex shrink-0 items-center">
        <slot name="after-text" />
      </span>
    </li>
  </ComboboxOption>
</template>

<script setup lang="ts">
import { ComboboxOption } from "@headlessui/vue"
import type { CustomComboboxOptionWrapper } from "@/components/inputs/input_combobox/CustomComboboxOptionWrapper"
import { computed } from "vue"

const props = defineProps<{
  wrapper: CustomComboboxOptionWrapper<any>
  text?: string
  disabled?: boolean
  muted?: boolean
}>()

defineOptions({
  inheritAttrs: false
})

const text = computed(() => (props.text ? props.text : props.wrapper.text))
</script>

<style scoped></style>
